import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor365: string;
  idsEmpreendimentos365: string[];
}

export function usePutAlterarProdutosInteresse() {
  const putData = async (props: Props) => {
    const PUT_ALTERAR = `${leadsWebEnviroment}/commom/leads/alterar-produtos-interesse/v1`;
    const { data } = await instance.put(PUT_ALTERAR, {
      idLeadCorretor365: props.idLeadCorretor365,
      idsEmpreendimentos365: props.idsEmpreendimentos365,
    });
    return data;
  };

  const mutation = useMutation({
    mutationFn: putData,
    onSuccess: () => {
      toast.success("Produtos alterados com sucesso!");
    },
    onError: (error: any) => {
      const errorMessages = error?.response?.data?.notifications?.map(
        (item: any) => item?.message
      ) || ["Erro ao alterar produtos"];
      toast.error(errorMessages.join(", "), { autoClose: 10000 });
    },
  });

  return mutation;
}
